import { FormControl, FormHelperText, FormLabel, Input } from '@mui/joy';
import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

interface Props<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label?: string;
  caption?: string;
  placeholder?: string;
  rules?: any;
  sx?: any;
  loading?: boolean;
  type?: string;
  step?: string;
}

function TextFieldElement<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  caption,
  rules,
  placeholder,
  sx,
  loading,
  type,
  step,
}: Props<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} sx={{ mb: 4, ...sx }}>
          {label && <FormLabel>{label}</FormLabel>}
          <Input
            type={type}
            placeholder={placeholder}
            {...field}
            disabled={loading}
            slotProps={step ? { input: { step } } : undefined}
          />
          {(error || caption) && (
            <FormHelperText>{error?.message || caption}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}

export default TextFieldElement;
